import {
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogLabel,
  AlertDialogOverlay,
} from '@reach/alert-dialog';
import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import IconCrossCircleFilled from '@picsart/icons/IconCrossCircleFilled';

import Button from '../Button';

import useStyles from './styles';
import IConfirmationModal from './types';

import '@reach/dialog/styles.css';

function ConfirmationModal({
  className,
  title,
  description,
  withIcon = false,
  cancelText = 'No',
  confirmText = 'Yes',
  onClose,
  onConfirm,
  icon = null,
}: IConfirmationModal) {
  const classes = useStyles();
  const cancelRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    requestAnimationFrame(() => {
      cancelRef.current?.focus();
    });
  }, []);

  return (
    <AlertDialogOverlay
      className={classNames(classes.root, className)}
      leastDestructiveRef={cancelRef}
      onDismiss={onClose}
    >
      <AlertDialogContent className={classes.modal}>
        <div className={classes.content}>
          <div>
            <AlertDialogLabel className={classes.title}>
              {withIcon ? <IconCrossCircleFilled fill="#E7000A" /> : icon}
              {title}
            </AlertDialogLabel>
            {description && (
              <AlertDialogDescription className={classes.description}>
                {description}
              </AlertDialogDescription>
            )}
          </div>
          <div className={classes.buttonsHolder}>
            <Button onClick={onClose} variant="tertiary" size="small" ref={cancelRef}>
              {cancelText}
            </Button>
            <Button onClick={onConfirm} variant="primary" size="small">
              {confirmText}
            </Button>
          </div>
        </div>
      </AlertDialogContent>
    </AlertDialogOverlay>
  );
}

export default ConfirmationModal;
